__turbopack_context__.v({
  "fieldOfView": "FieldOfView-module__FPb-la__fieldOfView",
  "viewArc": "FieldOfView-module__FPb-la__viewArc",
});
